import React from 'react';
interface GameUIProps {
  health: number;
  maxHealth: number;
  bossHealth?: number;
  bossMaxHealth?: number;
  combo: number;
  score: number;
  showBoss: boolean;
}
export function GameUI({
  health,
  maxHealth,
  bossHealth,
  bossMaxHealth,
  combo,
  score,
  showBoss
}: GameUIProps) {
  const healthPercent = health / maxHealth * 100;
  const bossHealthPercent = bossHealth && bossMaxHealth ? bossHealth / bossMaxHealth * 100 : 0;
  return <div className="absolute inset-0 pointer-events-none" data-id="element-19">
      {/* Player Health Bar */}
      <div className="absolute top-4 left-4 w-64" data-id="element-20">
        <div className="text-white text-sm font-bold mb-1 drop-shadow-lg" data-id="element-21">
          HEALTH
        </div>
        <div className="h-6 bg-black/50 border-2 border-white/30 rounded overflow-hidden" data-id="element-22">
          <div className="h-full bg-gradient-to-r from-green-500 to-green-400 transition-all duration-300" style={{
          width: `${healthPercent}%`
        }} data-id="element-23" />
        </div>
        <div className="text-white text-xs mt-1 drop-shadow-lg" data-id="element-24">
          {Math.ceil(health)} / {maxHealth}
        </div>
      </div>

      {/* Boss Health Bar */}
      {showBoss && bossHealth !== undefined && bossMaxHealth !== undefined && <div className="absolute top-4 right-4 w-80" data-id="element-25">
          <div className="text-red-400 text-sm font-bold mb-1 drop-shadow-lg text-right" data-id="element-26">
            BOSS
          </div>
          <div className="h-8 bg-black/50 border-2 border-red-500/50 rounded overflow-hidden" data-id="element-27">
            <div className="h-full bg-gradient-to-r from-red-600 to-red-500 transition-all duration-300" style={{
          width: `${bossHealthPercent}%`
        }} data-id="element-28" />
          </div>
          <div className="text-white text-xs mt-1 drop-shadow-lg text-right" data-id="element-29">
            {Math.ceil(bossHealth)} / {bossMaxHealth}
          </div>
        </div>}

      {/* Combo Counter */}
      {combo > 0 && <div className="absolute top-24 left-1/2 -translate-x-1/2" data-id="element-30">
          <div className="text-center" data-id="element-31">
            <div className="text-6xl font-bold text-yellow-400 drop-shadow-lg animate-pulse" style={{
          textShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 0 40px rgba(255, 215, 0, 0.4)',
          transform: `scale(${1 + combo * 0.05})`
        }} data-id="element-32">
              {combo}x
            </div>
            <div className="text-xl text-white font-bold drop-shadow-lg" data-id="element-33">
              COMBO!
            </div>
          </div>
        </div>}

      {/* Score */}
      <div className="absolute top-4 left-1/2 -translate-x-1/2" data-id="element-34">
        <div className="text-white text-sm font-bold mb-1 drop-shadow-lg text-center" data-id="element-35">
          SCORE
        </div>
        <div className="text-3xl font-bold text-yellow-300 drop-shadow-lg text-center" data-id="element-36">
          {score.toLocaleString()}
        </div>
      </div>

      {/* Controls */}
      <div className="absolute bottom-4 left-4 text-white/70 text-xs drop-shadow-lg" data-id="element-37">
        <div data-id="element-38">WASD/Arrows: Move</div>
        <div data-id="element-39">Space: Jump (double jump)</div>
        <div data-id="element-40">Z/X: Attack</div>
      </div>
    </div>;
}